import {
  Injectable,
  Inject,
  Input,
  ComponentFactoryResolver,
  ComponentRef,
  ComponentFactory
} from '@angular/core';
import { ChartService } from './chart.service';
import { PiechartComponent } from '../zoomcharts/piechart/piechart.component';
import { FacetchartComponent } from '../zoomcharts/facetchart/facetchart.component';
import { GeochartComponent } from '../zoomcharts/geochart/geochart.component';
import { NetchartComponent } from '../zoomcharts/netchart/netchart.component';
import { TimechartComponent } from '../zoomcharts/timechart/timechart.component';

@Injectable()
export class ZoomchartsService {
  license: string;
  licenseKey: string;
  componentArray: any = [];
  componentObject: any = {
    pieChart: PiechartComponent,
    facetChart: FacetchartComponent,
    geoChart: GeochartComponent,
    netChart: NetchartComponent,
    timeChart: TimechartComponent,
  }

  constructor(
    @Inject('config') private config,
    private chartService: ChartService,
    private resolver: ComponentFactoryResolver
  ) { }

  setLicenseKey(val: any) {
    this.license = val.license;
    this.licenseKey = val.licenseKey;
  }

  getLicense() {
    return this.license;
  }

  getLicenseKey() {
    return this.licenseKey;
  }

  setComponentArray(componentObj: any) {
    let id = componentObj.id;
    let component = componentObj.component;

    // 
    if (!this.componentArray[id]) {
      this.componentArray[id] = component;
    }
  }

  getRandomId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  createChartComponent(component) {
    // 
    const chartType = Object.keys(component.settings)[0];
    const factory = this.resolver.resolveComponentFactory(this.componentObject[chartType]);
    const componentRef = component.container.createComponent(factory);

    component.settings[chartType].container = component.settings[chartType].container || this.getRandomId();
    componentRef.instance.chartID = component.settings[chartType].container;
    componentRef.instance.settings = component.settings[chartType];
    componentRef.instance.type = chartType;

    // 
    this.chartService.setComponentObject({
      component: componentRef,
      id: component.id 
    });
  }

  getComponentById(id) {
    // 
    this.chartService.getComponentObject().subscribe(
      item => {
        item.id == id && this.setComponentArray({
          component: item.component,
          id: id
        });
      }
    );

    // 
    return new Promise(resolve => {
      resolve(id);
    });
  }

  async returnAddedComponent(id) {
    const chartID = <any>await this.getComponentById(id);
    return this.componentArray[chartID];
  }

  getComponent(id) {
    return this.returnAddedComponent(id);
  }

}
